import { FiTool } from "react-icons/fi";
import Collabse from "../../../components/Collabse";
import CancelBtn from "./CancelBtn";
import UploadBtn from "./UploadBtn";
import UrgentBtn from "./UrgentBtn";
import NoEmailsBtn from "./NoEmailsBtn";
import { useAppSelector } from "../../../redux/store";

const LMXTools = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const logicChannel = sessionStorage.getItem("mylmx-logic");
  const isFrenchOrSwiss =
    logicChannel === "france" || logicChannel === "swiss";

  return (
    <div>
      <Collabse Header={Header}>
        <div className="grid 2xl: grid-cols-4 gap-4">
          {!isAgency && (
            <div className="col-span-1">
              <UploadBtn />
            </div>
          )}

          <div className="col-span-1">
            <CancelBtn />
          </div>

          {!isFrenchOrSwiss && (
            <>
              <div className="col-span-1">
                <UrgentBtn />
              </div>

              <div className="col-span-1">
                <NoEmailsBtn />
              </div>
            </>
          )}
        </div>
      </Collabse>
    </div>
  );
};

const Header = () => {
  return (
    <h5>
      <FiTool />
      LMX Tools
    </h5>
  );
};

export default LMXTools;
